import React, { useCallback, useState, useEffect } from 'react'
import DestinationFilters from './DestinationFilters'
import StateDestinationFilter from './StateDestinationFilter'
import RegionDestinationFilter from './RegionDestinationFilter'

const deriveDestinationType = f => {
	if (f?.destinationType) return f.destinationType
	if (f?.destinationStates?.length > 0) return 'STATE'
	if (f?.destinationRegions?.length > 0) return 'REGION'
	return 'CITY'
}

export default function DestinationFilterWrapper({
	filters,
	setFilters,
	handleDestinationChange,
	handleFilterChange,
	labels,
	styles,
	isDarkMode,
	onDropoffLocationsChange,
}) {
	const derivedType = deriveDestinationType(filters)
	const [localDestinationType, setLocalDestinationType] = useState(derivedType)
	const destinationType = localDestinationType

	useEffect(() => {
		setLocalDestinationType(prev => (prev === derivedType ? prev : derivedType))
	}, [derivedType])

	const handleDestinationTypeChange = useCallback(
		newType => {
			if (newType === destinationType) return

			const hasExistingDestination =
				filters.dropoffLocations?.length > 0 ||
				filters.destinationStates?.length > 0 ||
				filters.destinationRegions?.length > 0 ||
				filters.dropCity ||
				filters.destination

			setFilters(prev => ({
				...prev,
				destinationType: newType,
				...(hasExistingDestination
					? {
							dropLat: '',
							dropLng: '',
							dropCity: '',
							dropState: '',
							dropStateName: '',
							destination: '',
							dropoffLocations: [],
							dropoffMaxDist: 100,
							destinationStates: [],
							destinationRegions: [],
					  }
					: {}),
				paginateSize: 1,
			}))
			setLocalDestinationType(newType)
		},
		[setFilters, filters, destinationType]
	)

	if (destinationType === 'CITY') {
		return (
			<DestinationFilters
				filters={filters}
				handleDestinationChange={handleDestinationChange}
				labels={labels}
				handleFilterChange={handleFilterChange}
				styles={styles}
				isDarkMode={isDarkMode}
				onDropoffLocationsChange={onDropoffLocationsChange}
				destinationType={destinationType}
				setDestinationType={handleDestinationTypeChange}
			/>
		)
	}

	if (destinationType === 'STATE') {
		return (
			<StateDestinationFilter
				filters={filters}
				setFilters={setFilters}
				labels={labels}
				styles={styles}
				isDarkMode={isDarkMode}
				destinationType={destinationType}
				setDestinationType={handleDestinationTypeChange}
			/>
		)
	}

	if (destinationType === 'REGION') {
		return (
			<RegionDestinationFilter
				filters={filters}
				setFilters={setFilters}
				labels={labels}
				styles={styles}
				isDarkMode={isDarkMode}
				destinationType={destinationType}
				setDestinationType={handleDestinationTypeChange}
			/>
		)
	}

	return null
}
